import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiSearch, FiTrash2 } from "react-icons/fi";
import { ArrowLeft } from "lucide-react";

const styles = {
  container: {
    background: "#f9fafb",
    minHeight: "100vh",
    padding: "24px",
    fontFamily: "'Inter', sans-serif",
   
  },

  billingWrapper: {
    background: "#fff",
    borderRadius: "12px",
    boxShadow: "0 8px 25px rgba(0,0,0,0.05)",
    maxWidth: "100%",
    margin: "0 auto",
    overflow: "hidden",
  },

  header: {
    background: "linear-gradient(135deg, #047857, #059669)",
    color: "#fff",
    padding: "20px 24px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  headerTitle: { fontSize: "22px", fontWeight: 700, margin: 0 },
  headerSubtitle: { fontSize: "14px", opacity: 0.85, margin: "4px 0 0" },

  content: { padding: "24px" },

  section: { marginBottom: "28px" },
  sectionTitle: { fontSize: "18px", fontWeight: 600, marginBottom: "12px" },

  formGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    gap: "16px",
  },

  col12: { gridColumn: "span 12" },
  col6: { gridColumn: "span 6" },

  label: { fontSize: "14px", fontWeight: 600, marginBottom: "6px" },

  input: {
    padding: "10px 14px",
    border: "1.5px solid #e5e7eb",
    borderRadius: "8px",
    fontSize: "15px",
    outline: "none",
    width: "100%",
  },

  textarea: {
    padding: "10px 14px",
    border: "1.5px solid #e5e7eb",
    borderRadius: "8px",
    fontSize: "15px",
    resize: "none",
    outline: "none",
    width: "100%",
  },

  searchContainer: { position: "relative", marginBottom: "16px" },
  searchInput: {
    padding: "12px 16px 12px 44px",
    borderRadius: "8px",
    border: "1.5px solid #e5e7eb",
    fontSize: "15px",
    width: "100%",
  },
  searchIcon: {
    position: "absolute",
    left: "14px",
    top: "50%",
    transform: "translateY(-50%)",
    color: "#6b7280",
  },

  buttonPrimary: {
    background: "#047857",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    padding: "10px 20px",
    fontSize: "15px",
    cursor: "pointer",
  },

  cartTable: {
    width: "100%",
    borderCollapse: "collapse",
    borderRadius: "8px",
    overflow: "hidden",
  },

  tableHeader: {
    background: "#f3f4f6",
    padding: "10px 16px",
    textAlign: "left",
    fontWeight: 600,
  },

  tableCell: {
    padding: "10px 16px",
    borderBottom: "1px solid #e5e7eb",
  },

  deleteButton: {
    background: "none",
    border: "none",
    cursor: "pointer",
    color: "#dc2626",
    fontSize: "18px",
  },

  emptyCartBox: {
    border: "2px dashed #d1d5db",
    borderRadius: "10px",
    padding: "32px",
    textAlign: "center",
    color: "#6b7280",
    background: "#fafafa",
  },

  emptyCartText: {
    fontSize: "15px",
  },
};

const SalesReturn = () => {
  const navigate = useNavigate(); // ✅ FIXED: added useNavigate hook

  const [returnItems, setReturnItems] = useState([]);
  const [form, setForm] = useState({
    returnId: "RET12345",
    returnDate: new Date().toISOString().slice(0, 10),
    invoiceNumber: "",
    patientName: "",
    doctorName: "",
    reason: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleAddItem = () => {
    const newItem = {
      id: Date.now(),
      name: "Paracetamol 500mg",
      qty: 1,
      price: 10,
    };
    setReturnItems([...returnItems, newItem]);
  };

  const handleDelete = (id) => {
    setReturnItems(returnItems.filter((i) => i.id !== id));
  };

  return (
    <div style={styles.container}>
        <div style={styles.toHeader}>
                <div className="flex items-center gap-4">
                  <button
                    onClick={() => navigate("/PharmacyBilling")}
                    className="p-3 m-3 bg-gray-100 hover:bg-gray-200 rounded-xl transition-all duration-300 group"
                  >
                    <ArrowLeft className="w-5 h-5 text-gray-600 group-hover:text-gray-800" />
                  </button>
                  <div>
                    <h1 className="text-3xl font-bold text-gray-900">
                 Sales Return
                    </h1>
                    <p className="text-gray-600 mt-1">
                    </p>
                  </div>
                </div>
              </div>
        
      <div style={styles.billingWrapper}>
        {/* Header */}
        <div style={styles.header}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px"}}>
         <div>
            <h2 style={styles.headerTitle}>Sales Return</h2>
              <p style={styles.headerSubtitle}>
                Manage product returns from customers efficiently
              </p>
            </div>
          </div>
          <div>
            Return ID: <strong>{form.returnId}</strong>
          </div>
        </div>

        {/* Content */}
        <div style={styles.content}>
          {/* Left Form */}
          <section style={styles.section}>
            <h3 style={styles.sectionTitle}>Return Information</h3>

            <div style={styles.formGrid}>
              <div style={styles.col6}>
                <label style={styles.label}>Invoice Number</label>
                <input
                  style={styles.input}
                  name="invoiceNumber"
                  value={form.invoiceNumber}
                  placeholder="Enter invoice no."
                  onChange={handleChange}
                />
              </div>

              <div style={styles.col6}>
                <label style={styles.label}>Return Date</label>
                <input
                  type="date"
                  style={styles.input}
                  name="returnDate"
                  value={form.returnDate}
                  onChange={handleChange}
                />
              </div>

              <div style={styles.col6}>
                <label style={styles.label}>Patient Name</label>
                <input
                  style={styles.input}
                  name="patientName"
                  placeholder="Enter patient name"
                  value={form.patientName}
                  onChange={handleChange}
                />
              </div>

              <div style={styles.col6}>
                <label style={styles.label}>Prescribing Doctor</label>
                <input
                  style={styles.input}
                  name="doctorName"
                  placeholder="Enter doctor name"
                  value={form.doctorName}
                  onChange={handleChange}
                />
              </div>

              <div style={styles.col12}>
                <label style={styles.label}>Reason for Return</label>
                <textarea
                  rows="2"
                  style={styles.textarea}
                  name="reason"
                  placeholder="Enter reason (e.g., wrong medicine, expired, etc.)"
                  value={form.reason}
                  onChange={handleChange}
                />
              </div>
            </div>
          </section>

          {/* Search */}
          <section style={styles.section}>
            <h3 style={styles.sectionTitle}>Search & Add Items</h3>
            <div style={styles.searchContainer}>
              <FiSearch style={styles.searchIcon} />
              <input
                style={styles.searchInput}
                placeholder="Search medicine by name, code, or scan barcode..."
              />
            </div>

            <button style={styles.buttonPrimary} onClick={handleAddItem}>
              + Add Sample Item
            </button>
          </section>

          {/* Items Table */}
          <section style={styles.section}>
            <h3 style={styles.sectionTitle}>
              Returned Items ({returnItems.length})
            </h3>
            {returnItems.length === 0 ? (
              <div style={styles.emptyCartBox}>
                <p style={styles.emptyCartText}>
                  No items added yet. Search and add medicines above.
                </p>
              </div>
            ) : (
              <table style={styles.cartTable}>
                <thead>
                  <tr>
                    <th style={styles.tableHeader}>Item Name</th>
                    <th style={styles.tableHeader}>Qty</th>
                    <th style={styles.tableHeader}>Price</th>
                    <th style={styles.tableHeader}>Total</th>
                    <th style={styles.tableHeader}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {returnItems.map((item) => (
                    <tr key={item.id}>
                      <td style={styles.tableCell}>{item.name}</td>
                      <td style={styles.tableCell}>{item.qty}</td>
                      <td style={styles.tableCell}>₹{item.price.toFixed(2)}</td>
                      <td style={styles.tableCell}>
                        ₹{(item.price * item.qty).toFixed(2)}
                      </td>
                      <td style={styles.tableCell}>
                        <button
                          style={styles.deleteButton}
                          onClick={() => handleDelete(item.id)}
                        >
                          <FiTrash2 />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </section>
        </div>
      </div>
    </div>
  );
};

export default SalesReturn;
